import React from 'react';
import { ClientLogo } from './ClientLogo';
import { clients } from '../data/clients';
type LogoMarqueeProps = {
  reverse?: boolean;
};

// Repeat the set so one half of the track is always wider than the viewport.
const track = [...clients, ...clients, ...clients];
export function LogoMarquee({
  reverse = false
}: LogoMarqueeProps) {
  return <div className="marquee-mask group relative mx-auto w-full max-w-[900px] overflow-hidden" aria-hidden="true" data-id="element-384" data-mp="2mw5ytx7e8w9l">
      <div className={`${reverse ? 'marquee-track--reverse' : 'marquee-track'} flex w-max items-center group-hover:[animation-play-state:paused]`} data-id="element-385" data-mp="2rviun7g8tdob">
        {[0, 1].map(half => <div key={half} className="flex items-center" data-id="element-386" data-mp="31piyl5zsgcvg">
            {track.map((client, i) => <div key={`${half}-${client.id}-${i}`} className="flex shrink-0 items-center px-5 opacity-90 transition-opacity duration-150 hover:opacity-100 md:px-7" data-id="element-387" data-mp="36o2k55agzmna" data-mpi={i}>
                <ClientLogo id={client.id} data-id="element-388" data-mp="26pvj7uhffry" />
              </div>)}
          </div>)}
      </div>
    </div>;
}